import React from 'react';
import {Divider, Button, Segment, Container} from 'semantic-ui-react';

export class Left extends React.Component {
  render() {
    const {expanded, toggle} = this.props;

    if (expanded) {
      return (
        <Segment id="left" className="fullHeight leftOffset">
          <Container textAlign="right">
            <Button
              basic
              onClick={toggle}
              icon="angle double left black"
              title="Collapse side navigation"
            />
          </Container>
          <div id="leftNavMenuContainer">{this.props.children}</div>
        </Segment>
      );
    } else {
      return (
        <Segment id="left" className="fullHeight collapsed">
          <Button
            basic
            onClick={toggle}
            icon="angle double right black"
            title="Expand side navigation"
          />
        </Segment>
      );
    }
  }
}

export default Left;
